var _style, _g, _g2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChocolatemilk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F0C15E;}\n\t.st1{fill:#683C11;}\n\t.st2{fill:#7D4E24;}\n\t.st3{fill:#B17F4A;}\n\t.st4{fill:#FFFFFF;}\n\t.st5{font-family:'ArialMT';}\n\t.st6{font-size:10.9562px;}\n\t.st7{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.63,182.83c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C29.33,148.54,63.94,182.83,106.63,182.83"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 97.01,
    y: 46.4,
    className: "st1",
    width: 19.37,
    height: 7.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.19,
    y: 70.88,
    className: "st1",
    width: 40.29,
    height: 87.71
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "116.39,53.52 97,53.44 96.2,70.89 136.48,70.89  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.85,
    y: 70.88,
    className: "st2",
    width: 40.29,
    height: 87.71
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "97,53.44 76.85,70.89 117.14,70.89  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M105.26,146.81H89.12c-4.34,0-7.85-3.52-7.85-7.85V90.54c0-4.34,3.52-7.85,7.85-7.85h16.15 c4.34,0,7.85,3.52,7.85,7.85v48.41C113.12,143.3,109.6,146.81,105.26,146.81z"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 87.6158 133.5478)",
    className: "st4 st5 st6"
  }, "Milk")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M97.72,94.94c0.55,0.77,1.1,1.51,1.63,2.27c1.58,2.26,3.04,4.59,4.3,7.04c0.8,1.57,1.52,3.17,2.04,4.86 c0.26,0.85,0.47,1.72,0.55,2.61c0.17,1.83-0.17,3.56-1.1,5.14c-1.33,2.26-3.3,3.67-5.88,4.16c-4.47,0.85-8.89-2.07-9.89-6.51 c-0.31-1.38-0.26-2.76,0.05-4.13c0.39-1.75,1.05-3.41,1.82-5.02c1.29-2.71,2.86-5.26,4.56-7.73c0.6-0.86,1.22-1.71,1.84-2.56 C97.65,95.03,97.67,95,97.72,94.94z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M77.08,123.58c0,0-0.19,0.13-0.45,0.29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChocolatemilk);
export default __webpack_public_path__ + "static/media/Chocolatemilk.6e4284c4e354025944150687f74a31f5.svg";
export { ForwardRef as ReactComponent };